import { useEffect } from 'react';

const CursorTrail = () => {
  useEffect(() => {
    let trails = [];
    const maxTrails = 12;
    
    const handleMouseMove = (e) => {
      // Create trail element with K logo image
      const trail = document.createElement('img');
      trail.className = 'cursor-trail';
      trail.src = 'https://customer-assets.emergentagent.com/job_f2ee6b04-88a4-4dce-acdb-9e470155c901/artifacts/8mgrjxkj_K%202.png';
      trail.alt = 'K';
      trail.style.left = e.clientX + 'px';
      trail.style.top = e.clientY + 'px';
      
      document.body.appendChild(trail);
      trails.push(trail);
      
      // Remove old trails
      if (trails.length > maxTrails) {
        const oldTrail = trails.shift();
        oldTrail.remove();
      }
      
      // Animate and remove trail
      setTimeout(() => {
        trail.style.opacity = '0';
        trail.style.transform = 'translate(-50%, -50%) scale(1.5) rotate(15deg)';
      }, 50);
      
      setTimeout(() => {
        trail.remove();
        trails = trails.filter(t => t !== trail);
      }, 800);
    };
    
    document.addEventListener('mousemove', handleMouseMove);
    
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      trails.forEach(trail => trail.remove());
    };
  }, []);
  
  return null;
};

export default CursorTrail;